import { createSlice } from "@reduxjs/toolkit";
import { IFacultyConnectClassDetailSlice } from "../../../models/faculty/facultyConnect";

const initialFacultyConnectClassState: IFacultyConnectClassDetailSlice = {
    facultyClassDetails: undefined,
};

const facultyConnectClassDetailSlice = createSlice({
    name: "facultyConnectClass",
    initialState: initialFacultyConnectClassState,
    reducers: {
        setFacultyConnectClassDetails: (state, action: { payload: any }) => {
            state.facultyClassDetails = action.payload;
        },
    },
});

export const { setFacultyConnectClassDetails } = facultyConnectClassDetailSlice.actions;

const facultyConnectClassDetailReducer = facultyConnectClassDetailSlice.reducer;

export type facultyConnectClassDetailState = ReturnType<typeof facultyConnectClassDetailReducer>;

export default facultyConnectClassDetailReducer;
